import { frontendURL } from 'dashboard/helper/URLHelper';
const Onboarding = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_checklist',
      component: Onboarding,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
